module.exports = __webpack_public_path__ + "static/media/laptop.fdbab94d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/laptop.svg
// module id = 519
// module chunks = 4